import $ from 'jquery';
import * as Rematrix from 'rematrix';
import 'slick-carousel';

 var mouseCoords = {
   'sneakerhead': { x: 0, y: 0, prevX: 0, prevY: 0},
   'allAmerican': { x: 0, y: 0, prevX: 0, prevY: 0},
   'prep':        { x: 0, y: 0, prevX: 0, prevY: 0},
   'active':      { x: 0, y: 0, prevX: 0, prevY: 0},
   'trendsetter': { x: 0, y: 0, prevX: 0, prevY: 0},
 };

 var titles = ['all', 'american', 'sneaker', 'head', 'preptitle', 'activetitle', 'trendsettertitle'];

 var DICTIONARY = {
   'shoes':    { speed: 0.02, },
   'cargo':    { speed: 0.05, },
   'hoodie':   { speed: 0.07, },
   'sneaker':  { speed: 0.05, },
   'head':     { speed: 0.05, },
   'oxford':   { speed: 0.07, },
   'all':      { speed: 0.05, },
   'american': { speed: 0.05, },
   'dress':    { speed: 0.035, },
   'hat':      { speed: 0.06, },
   'jeans':    { speed: 0.05, },
   'preptitle':{ speed: 0.05, },
   'jacket':   { speed: 0.035, },
   'pshoes':   { speed: 0.06, },
   'shorts':   { speed: 0.05, },
   'activetitle':{ speed: 0.05, },
   'ashorts':  { speed: 0.03, },
   'shirt':    { speed: 0.07, },
   'trendsettertitle':{ speed: 0.05, },
   'tjeans':   { speed: 0.07, },
   'tshirt':   { speed: 0.03, },
 };

 const mouseMove = (screen, elements, e) => {

   mouseCoords[screen].x = e.clientX || e.pageX;
   mouseCoords[screen].y = e.clientY || e.pageY;

   let x =  mouseCoords[screen].x - ($(window).width() / 2);
   let y =  mouseCoords[screen].y - ($(window).height() / 2);

   const diffX = (mouseCoords[screen].prevX - x - 0.2);
   const diffY = (mouseCoords[screen].prevY - y - 0.2);

   mouseCoords[screen].prevX = x;
   mouseCoords[screen].prevY = y;

   elements.forEach((elem, ix) => {
     let tx = diffX * DICTIONARY[elem].speed;
     let ty = diffY * DICTIONARY[elem].speed;

     let translate = Rematrix.translate(tx, ty);
     var transform = $('.'+elem).attr('transform').replace(/,/g, ", ");;
     transform = Rematrix.parse(transform);
     const product = [transform, translate].reduce(Rematrix.multiply);
     var css = `matrix(${product[0]}, ${product[1]}, ${product[4]}, ${product[5]}, ${product[12]}, ${product[13]})`;

    if (Math.abs(diffX) > 50 && !titles.includes(elem)) {
      if(diffX > 0) {
        $('.'+elem+" image").css('animation-name', 'cloth');
      } else {
        $('.'+elem+" image").css('animation-name', 'cloth-back');
      };
    }
    $('.'+elem).attr('transform', css);
    $('.'+elem+" image").css('animation-duration', '0.5s');
    $('.'+elem+" image").css('animation-delay', (0.05*(ix-1)) + 's');
    $('.'+elem+" image").css('animation-timing-function', 'ease-in-out');
  });
};

var carouselsLoaded = 0;

$('.first-row').on('init', function(event, slick){
  var event = new Event('carousel-loaded');
  document.dispatchEvent(event);

});
$('.second-row').on('init', function(event, slick){
  var event = new Event('carousel-loaded');
  document.dispatchEvent(event);

});
$('.third-row').on('init', function(event, slick){
  var event = new Event('carousel-loaded');
  document.dispatchEvent(event);
});

document.addEventListener('carousel-loaded', () => {
  carouselsLoaded++;
  if (carouselsLoaded == 3) {
    $('.modal').css({'z-index':2});
    $('.modal').css({'opacity':1});

    $('.modal .slick-slider').css({'opacity':1});
    carouselsLoaded = 0;
  }
});

const click = (products) => {
  if (moreInfoOpened) return;

  if ($(window).width() <= 768) {
    $('.brand').hide();
  }

  var slickOptions = {
    centerMode: true,
    slidesToShow: 3,
    infinite: true,
    arrows: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    initialSlide: 2,
    centerPadding: 0,
    responsive: [
     {
       breakpoint: 550,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
  };

  if (!$('.first-row').first().is(':empty')){
    $(".first-row, .second-row, .third-row").slick("unslick");
    $(".first-row, .second-row, .third-row").empty();
    //$(".first-row, .second-row, .third-row").css({opacity: 0});
  }

  $(".first-row, .second-row, .third-row").on('mousemove', function(e) {
    var sw = $(window).width()/3;
    if ((e.pageX > 0) && (e.pageX < sw)){
      $(this).css({'cursor': 'url("src/images/carousel-cursor-back.png"), auto'});
    } else
      if (e.pageX > 2*sw){
        $(this).css({'cursor': 'url("src/images/carousel-cursor.png"), auto'});
      } else {
        $(this).css({'cursor': ''});
      }
  });


  var before = products.section, after = products.section, cn;
  switch (products.section) {
    case 'sneakerhead':
      before = "SNEAKER"; after = "head"; cn = "s"; break;
    case 'allAmerican':
      before = "ALL"; after = "AMERICAN"; cn = "aa"; break;
    case 'prep':
      cn = "p"; break;
    case 'active':
      cn = "a"; break;
    case 'trendsetter':
      cn = "t"; break;
    default:

  }
  $('.modal').attr('data-before', before);
  $('.modal').attr('data-after', after);
  $('.modal').attr('class', 'modal');
  $('.modal').addClass(cn);

  var folder_path = "/src/images/products/" + products.section + '/';

  ['first', 'second', 'third'].forEach((row) => {
    products[row].forEach((p) => {
      var file_path = folder_path + p.path;

      var slide = $(
        '<div class="slide-content" onclick="gotolink(event,\''+ p.link.toString() +'\')">'+
          '<div class="slide-image">'+
            '<img src="'+file_path+'"/>'+
          '</div>'+
          '<div class="slide-info">'+
            '<span class="number">'+p.number+'</span >'+
            '<span class="title">'+p.title+'</span>'+
            '<span class="item-brand">'+p.brand+'</span>'+
          '</div>'+
        '</div>'
      );

      if (p.cottonFunFacts || p.UrbanDaddyFunFacts) {
        var hotspot = $('<div class="hotspot"></div>');
        slide.append(hotspot);

        var cf = p.cottonFunFacts != '' ? '<span>' + p.cottonFunFacts + '</span><br>': '';
        var uf = p.UrbanDaddyFunFact != '' ? '<span>' + p.UrbanDaddyFunFacts + '</span>': '';

        var funfact = $(
          '<div class="funfact">' +
            cf +
            uf +
          '</div>'
        );
        slide.append(funfact);
      }
      $('.'+row+'-row').append(slide);
    });
    $('.'+row+'-row').slick(slickOptions);
  });
};

$('.more-info').click(function(e){

  if ($(this).children('span').text() === 'MORE INFO') {
    $(this).siblings('svg').animate({opacity: 0}, 500);
    $(this).siblings('.trademarks').delay(200).animate({opacity: 1}, 500);
    $(this).siblings('.heros').delay(200).animate({opacity: 1}, 500);

    $(this).children('img').animate({opacity: 1}, 500);
    $(this).children('.hanger').animate({opacity: 0}, 500);
    $(this).children('span').html('GO BACK');
    $('.carousel-controls').css({'z-index': '-99'});
    moreInfoOpened = true;
  } else {
    $(this).siblings('.trademarks').animate({opacity: 0}, 500);
    $(this).siblings('.heros').animate({opacity: 0}, 500);
    $(this).siblings('svg').delay(200).animate({opacity:1}, 500);

    $(this).children('.hanger').animate({opacity: 1}, 500);
    $(this).children('img').animate({opacity: 0}, 500);
    $(this).children('span').html('MORE INFO');
    $('.carousel-controls').css({'z-index': ''});
    moreInfoOpened = false;
  }
  e.stopPropagation();
});

$(".first-row, .second-row, .third-row").on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  $('.urban-star').removeClass('open');
  var direction;
  if (Math.abs(nextSlide - currentSlide) == 1) {
    direction = (nextSlide - currentSlide > 0) ? "right" : "left";
  }
  else {
    direction = (nextSlide - currentSlide > 0) ? "left" : "right";
  }

  if (direction == 'left') {
    $(slick.$slides[currentSlide]).find('img').css({'animation': ''});
    $(slick.$slides[nextSlide]).find('img').css({'animation': 'cloth-carousel-back 0.8s ease-in-out'});
  } else {
    $(slick.$slides[currentSlide]).find('img').css({'animation': ''});
    $(slick.$slides[nextSlide]).find('img').css({'animation': 'cloth-carousel 0.8s ease-in-out'});
  }
});

/******************************************************************************/
/*************************** EVENTS SWIPE AND RESIZE **************************/
/******************************************************************************/

$(window).resize(() => {
  var theWidth = Math.max($(window).width(), $(window).height()*1.6);
  $('.bg-anim').css({width: theWidth});
});

let touchstartX = 0;
let touchendX = 0;


var car = document.getElementsByClassName("carousel")[0];

$('.carousel')[0].addEventListener("drag", function( event ) {
  console.log("hola");
}, false);

car.addEventListener('touchstart', function(event) {
  touchstartX = event.changedTouches[0].screenX;
}, false);

car.addEventListener('touchend', function(event) {
  touchendX = event.changedTouches[0].screenX;
  handleGesture();
}, false);

car.addEventListener('wheel', function(event) {
  event.preventDefault();
  if (isSliding) return;
  isSliding = true;
  if(event.deltaX < 0) {
    slide('left');
  } else {
    slide('right');
  };
}, false);

function handleGesture() {
  if (moreInfoOpened) return;
  if (touchendX < touchstartX && Math.abs(touchendX - touchstartX) > 20) { slide('right'); }
  if (touchendX > touchstartX && Math.abs(touchendX - touchstartX) > 20) { slide('left'); }
}

export { mouseMove, click };
